import React, { useState } from 'react'
import SearchPage from 'containers/SearchPage'
import { Span, Timestamp } from 'components/datatable'
import { Table } from '@arnsbogroup/react-voicearchive'
import classNames from 'classnames'
import useCurrentUser from 'hooks/useCurrentUser'

const TaskSearchPage = ( { history, ...props } ) => {
    const { roles = [] } = useCurrentUser()
    const [highlightedRow, setHighlightedRow] = useState(null)
    
    const body = () => {
        if (roles.includes('coordinator')) {
            return {
                uid: Span,
                type: Span,
                title: Span,
                status: Span,
                deadline: (task) => <Timestamp includeStatus >{task.deadline}</Timestamp>,
                customer: Span,
                supplier: Span,
                customerRef: Span,
            }
        } else {
            return {
                uid: Span,
                deadline: (task) => <Timestamp includeStatus >{task.deadline}</Timestamp>,
                type: Span,
                supplier: Span,
                supplierStatus: Span,
                title: Span,
                orderid: Span
            }
        }
    }

    const nonExactBody = () => {
        if (roles.includes('coordinator')) {
            return {
                uid: Span,
                title: Span,
            }
        } else {
            return {
                deadline: (task) => <Timestamp includeStatus >{task.deadline}</Timestamp>,
                title: Span,
            }
        }
    }
    
    const head = () => {
        if (roles.includes('coordinator')) {
            return {
                uid: { sortable: true, className: 'w-20' },
                title: { sortable: true },
                type: { sortable: true, className: 'w-20'},
                status: { sortable: true, className: 'w-1/6' },
                customer: { sortable: true },
            }
        } else {
            return {
                uid: { sortable: true, className: 'w-20', label: '#' },
                type: { sortable: true, label: 'Type', className: 'w-20' },
                deadline: { sortable: true },
                supplierStatus: { className: 'w-1/6', label: 'Status' },
                title: { sortable: true },
                orderid: { sortable: true , label: 'Order ID'},
            }
        }
    }
    
    const onClick = (childProps) => {
        setHighlightedRow(childProps.uid)
        if (roles.includes('coordinator')) {
            return history.push(`/task/${childProps.uid}?currentOrderId=${childProps.orderid}&currentTaskId=${childProps.uid}&v=${+Date.now()}`)
        } else {
            return history.push(`/jobs/${props.match.params.state}/${childProps.uid}?state=${props.match.params.state}`)
        }
    }

    const FilesReadyForProduction = ({ producerIsNotified, customerapproval }) => {
        if (+producerIsNotified && !(+customerapproval)) {
            return (
                <span className="text-center text-sm">
                    <i class="fa fa-file-check text-green-400 fa-fw" title="Files are ready for production"></i>
                </span>
            )
        }
        return null
    }

    return(
        <SearchPage {...props}
            baseApiUrl="/rest/v2/task"
            indicators={[
                FilesReadyForProduction
            ]}
            components={{
                Tr: ({ childProps, ...innerProps }) => (
                    <Table.Tr
                        {...innerProps }
                        className={classNames({
                        'cursor-pointer': !!childProps,
                        'bg-blue-50': highlightedRow == childProps?.uid,
                        })}
                        onClick={childProps?.uid ? () => onClick(childProps) : undefined}
                    />
                )
            }}
            head={head()}
            body={!props.match.isExact ? nonExactBody() : body()}
        />
    )
}

export default TaskSearchPage
